import * as angular from 'angular';
import { RwfUserInteraction as RwfUserInteraction_Base, LoginOperation, ValidateCompany } from "@common/rwf/rwfuserinteraction";
import { DialogService } from "@services/dialogservice";
import { CompatibilityService } from "../services/compatibilityservice";
import { CtrlSelectCompany } from './selectcompany.ctrl';
import { ShowModalLogin } from "./login";
import { InvoiceEditItem } from '../KWFUtils';
import { GetRowItem, GetGrid } from '@common/navkendo';
import { fn } from '@common/utils';
import { TRouteInstanceSource } from '@common/rwf/routeinstancemodel';
import { CtrlMassRouteInstances } from '../editform/massroute/massroute.ctrl';

/** RWF Desktop App UserInteraction Service */
export class RwfUserInteraction extends RwfUserInteraction_Base {
    static $inject = ["CompatibilityService", "DialogService"];
    constructor($c: CompatibilityService, readonly DialogService: DialogService) {
        super($c);
    }

    ModalLogin<TLoginResult>(operation: LoginOperation<TLoginResult>): PromiseLike<TLoginResult> {
        return ShowModalLogin(operation, this.DialogService);
    }

    ModalSelectCompany(Companies: string[] | PromiseLike<string[]>, validateCompany?: ValidateCompany): PromiseLike<string> {
        return CtrlSelectCompany.ModalSelectCompany(<CompatibilityService>this.$c, Companies, validateCompany);
    }

    EditWorkflowInstance(context: CompatibilityService | Element, evt: Event, readOnly: boolean) {
        var rowitem = GetRowItem(evt);

        if (!rowitem)
            return;
        evt.cancelBubble = true;

        if (context instanceof Element) {
            var $c = angular.element(context).injector().get("CompatibilityService");
        } else {
            $c = context;
        }

        fn.UISafe(InvoiceEditItem($c, rowitem, undefined, readOnly).then(() => {
            var grid = GetGrid(evt);
            if (grid)
                grid.element.kendoNavBusyIndicator(true);
        }));
    }

    ModalMassRouteInstances(myInvoices: TRouteInstanceSource[], navUrl: string) {
        return CtrlMassRouteInstances.ModalMassRouteInstances(this.$c as CompatibilityService, myInvoices, navUrl);
    }
}
